import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ModalController } from '@ionic/angular';

import { Provider } from '../../core/models/provider.model';
import { Event } from '../../core/models/event.model';
import { Booking } from '../../core/models/booking.model';
import { BookingAttendee } from '../../core/models/booking-attendee.model';
import { User } from '../../core/models/user.model';

import { AttendeeFormModalComponent } from './attendee-form-modal/attendee-form-modal.component';

import { ChangeDetectorRef } from '@angular/core';

import { PpPhonePipe } from '../pipes/pp-phone.pipe';
 
@Component({
  selector: 'app-event-booking-attendees-management',
  templateUrl: './event-booking-attendees-management.component.html',
  styleUrls: ['./event-booking-attendees-management.component.scss'],
  providers: [PpPhonePipe] // Provide the pipe here
})
export class EventBookingAttendeesManagementComponent implements OnInit {


  @Input() event: Event;
  @Input() eventBooking: Booking;
  @Input() provider: Provider;
  @Input() mode: 'edit'|'add';

  @Output() bookingAttendeesChanged = new EventEmitter<BookingAttendee[]>();

  constructor( 
    private cdRef: ChangeDetectorRef,
    private modalCtrl: ModalController,
      

  ) { console.log('ababab'); }

  ngOnInit() { console.log('sdgsdg');}

  removeAttendee(index: number) {

    console.log('Removing attendee at index:', index);
    this.eventBooking.removeBookingAttendeeByIndex(index);
    this.bookingAttendeesChanged.emit( this.eventBooking.bookingAttendees );
    
  }



  openAttendeeEditor( provider: Provider, event: Event, eventBooking: Booking, mode: 'add'|'edit', bookingAttendee: BookingAttendee = null ) {

    /*if ( this.readonly ) {
      //this.presentToast('Nimate dostopnih pravic!');
      this.presentToast( this.translate.instant('COMMON.NO_ACCESS') );
      return false;
    }*/

    const componentProps = {
        provider: provider,  
        event: event,  
        eventBooking: eventBooking,
        mode: mode  
    }

    if ( bookingAttendee ) {

      if ( mode === 'add' ) {
        throw Error('In add mode booking attendee should not be set!');
      }

      componentProps['bookingAttendee'] = bookingAttendee;

    }

    this.modalCtrl.create({
      component: AttendeeFormModalComponent,
      cssClass: 'my-modal',
      componentProps: componentProps
      
    }).then(modal => {

      modal.present();
      return modal.onDidDismiss();

    }).then(result => {

      console.log(result);

      if ( result.role === 'attendeeAdded' ) {
        console.log( 'foooo' );
        console.log( result.data.bookingAttendee );

        if ( !result.data.bookingAttendee ) {
          throw Error('Attendee data missing!');
        }

        this.eventBooking.addBookingAttendee( result.data.bookingAttendee );


        console.log( 'addBookingAttendee .... emit event' );
        this.bookingAttendeesChanged.emit( this.eventBooking.bookingAttendees );

        console.log( this.eventBooking.partySize );

        this.cdRef.detectChanges();  // Force UI refresh

      }

      if ( result.role === 'attendeeEdited' ) {
        console.log( 'edited' );
        console.log( result.data.bookingAttendee );

        if ( !result.data.bookingAttendee ) {
          throw Error('Attendee data missing!');
        }

        this.eventBooking.editBookingAttendee( result.data.bookingAttendee );
        this.bookingAttendeesChanged.emit( this.eventBooking.bookingAttendees );

        this.cdRef.detectChanges();  // Force UI refresh

      }


    });
  } 

}
